<template>
    <VFooter class="pa-0" :order="1" color="transparent" flat absolute app>
        <VCard :style="backgroundStyle" class="w-100" flat rounded="0">
            <VContainer class="d-flex align-center pa-1">
                <VSpacer />
                <NuxtLink v-for="footerLink in footerLinks" to="/"
                    class="d-inline-block text-decoration-none text-high-emphasis">
                    <span class="text-caption">
                        {{ footerLink.text }}
                    </span>
                    <span v-if="footerLink !== footerLinks[footerLinks.length - 1]"
                        class="text-caption text-medium-emphasis mx-2">
                        •
                    </span>
                </NuxtLink>
            </VContainer>
        </VCard>
    </VFooter>
</template>

<script setup>
import { useAppStore } from '@S/appStore.ts';
import { useTheme } from 'vuetify';
let store = useAppStore();
const theme = useTheme();
const currentTime = ref(new Date());

const footerLinks = [
    {
        text: 'Dashboard',
        to: '/dashboard'
    },
    {
        text: 'Profile',
        to: '/account'
    },
    {
        text: 'Orders',
        to: '/orders'
    }
];

const greeting = computed(() => {
    const hour = currentTime.value.getHours();

    if (hour >= 0 && hour < 12) {
        return 'Good Morning';
    } else if (hour >= 12 && hour < 18) {
        return 'Good Afternoon';
    } else if (hour >= 18 && hour < 21) {
        return 'Good Evening';
    } else {
        return 'Good Night';
    }
});

const backgroundStyle = computed(() => {
    return `background-color: rgba(${theme.global.name.value === 'light' ? '255, 255, 255' : '16, 16, 16'}, ${store.deviceType === 'Desktop' ? theme.global.name.value === 'light' ? .95 : .8 : 1});
        transition: background-color .15s ease, backdrop-filter .15s ease;
        ${store.deviceType === 'Desktop' ? 'backdrop-filter: blur(5px) saturate(250%); box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);' : ''}`;
});
</script>

<style scoped>
.social-item {
    filter: grayscale(100%);
    transition: .5s;
    cursor: pointer
}

.social-item:hover {
    filter: grayscale(0%);
    transition: .5s;
}
</style>